export default "__VITE_ASSET__2FwgYAWb3xsymnmHYaIUNg__"